import React from 'react'
import OrderItem from './OrderItem'

const OrderStatusList = ({ lineitems }) => {
    return (
        <div className="order-list">
            {lineitems.map(item => (
                <OrderItem key={item.dishId} item={item} />
            ))}
        </div>
    )
}

export default OrderStatusList
